import toast from 'react-hot-toast';
import { setLoader, proceedClick, forceStateUpdate, setAppView } from './index';
import { EVENT_TYPE, SOCKET_PRIMARY_ROUTE, SOCKET_SECONDARY_ROUTE } from '../../constants';
let socket;
let session;

export const hideLoader = () => async (dispatch) => {
  dispatch(
    setLoader({
      loader: false,
    }),
  );
};

export const showLoader = () => async (dispatch) => {
  dispatch(
    setLoader({
      loader: true,
    }),
  );
};

export const proceedHandler = (bForce, displayName) => async (dispatch, getState) => {
  const {
    app: { DRMode, originalEventType },
  } = getState();
  if (!DRMode && socket) {
    if (displayName) {
      socket.send(`${SOCKET_PRIMARY_ROUTE.OPERATION}${SOCKET_SECONDARY_ROUTE.NAME_CHANGE}{"name": "${displayName}"}`);
      if (originalEventType === EVENT_TYPE.WEB_STUDIO && !bForce) {
        session.userDisplay = displayName;
        session.bForce = bForce;
        socket.send(`${SOCKET_PRIMARY_ROUTE.OPERATION}${SOCKET_SECONDARY_ROUTE.AV_TOKEN}`);
        return;
      }
    }
  }
  dispatch(
    proceedClick({
      displayName,
      bForce,
    }),
  );
  //  dispatch(
  //    setAppView()
  // );
  if (bForce) {
    session.start(true);
  }
};

export const setSessionRef = (userSession) => {
  session = userSession;
  if (session.socket) {
    socket = session.socket;
  }
};

export const showNotification = (message, config = {}) => {
  toast(message, config);
};

export const hideNotification = () => {
  toast.remove();
};

window.forceStateUpdate = (newState) => (dispatch) => {
  dispatch(forceStateUpdate(newState));
  dispatch(setAppView());
};

window.setStoreState = (newState) => (dispatch) => {
  dispatch(forceStateUpdate(newState));
};
